module.exports = __webpack_public_path__ + "img/N2M4_new.dc814390.jpg";